var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationProvider',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_vm._t("default"),_c('span',{staticClass:"error"},[_vm._v(_vm._s(errors[0]))])]}}],null,true)},'ValidationProvider',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }